import classNames from 'classnames';
import Select from 'react-select';

//  Import core block libraries
const { __ } = wp.i18n;
const { InspectorControls } = wp.blockEditor;
const {
	PanelBody,
	PanelRow,
	ServerSideRender,
	TextControl,
	RadioControl,
	SelectControl,
	Spinner,
} = wp.components;
const { registerBlockType } = wp.blocks;
const { Component, Fragment } = wp.element;

export class SelectFAQGroups extends Component {
	constructor( props ) {
		super(); // or super(props); ??

		this.state = {
			loading: false,
			groups: [],
		};
		this.props = props;
	}

	componentDidMount() {
		//console.log('componentDidMount: <SelectFAQGroups />');

		this.setState( { loading: true } );

		const url = 'flexible-faqs/v1/groups';

		wp.apiFetch( { path: url, method: 'GET' } ).then(
			( data ) => {
				const groups = [];

				let newLabelObj = {};
				const entries = Object.entries( data );
				for ( const [ key, value ] of entries ) {
					//console.log(key, value);

					// disable empty FAQ group select options
					const itemStatus = value.includes( '(0)' );
					const tmp = {
						value: key,
						isDisabled: itemStatus,
						label: value,
					};

					// if the fetched ID is the same as the currently selected ID then update label
					if ( JSON.parse( this.props.faqGroupId ).value == key ) {
						newLabelObj = tmp; //JSON.parse(this.props.faqGroupId).label;
						//console.log('tmp: ', tmp);
						//console.log('VAL', JSON.parse(this.props.faqGroupId).value);
					}
					//console.log(JSON.parse(this.props.faqGroupId), key, value);

					groups.push( tmp );
				}

				this.setState(
					{
						groups,
						loading: false,
					},
					() => {
						const { setAttributes } = this.props;
						//console.log('newLabelObj', newLabelObj);

						// only update dropdown label if there is one currently selected (i.e. this won't be the case for new block instances)
						if ( newLabelObj.hasOwnProperty( 'value' ) ) {
							setAttributes( {
								group: newLabelObj.value,
								faqGroupId: JSON.stringify( newLabelObj ),
							} );
						}
					}
				);

				return data;
			},
			( err ) => {
				return err;
			}
		);
	}

	componentDidUpdate() {
		//console.log('componentDidUpdate: <SelectFAQGroups />');
	}

	updateFaqsGroupSelect( newVal ) {
		const { setAttributes } = this.props;
		// const url = `flexible-faqs/v1/get-group-faqs/${newVal.value}`;
		const id = newVal;

		//console.log('Update FAQ group selection!', JSON.stringify(id.value));

		setAttributes( {
			group: id.value,
			faqGroupId: JSON.stringify( id ),
		} );
	}

	render() {
		const {
			setAttributes,
			faqGroupId,
			multi = true,
			className,
		} = this.props;
		//console.log(JSON.stringify(this.props));

		// Not really needed as this displays a spinning icon EVERY time an FAQ block is clicked on which doesn't look great.
		// if ( this.state.loading ) {
		//   return (
		//     <p style={{'display': 'flex', 'align-items': 'center'}} className={className} >
		//       <Spinner />
		//       { __( 'Loading post types', 'flexible-faqs' ) }
		//     </p>
		//   );
		// }

		//console.log('fp: ', faqGroupId);

		const selectStyles = {
			container: ( styles ) => ( {
				...styles,
				'& div[class$="-Input"]': {
					'& input:focus': {
						boxShadow: 'none',
					},
				},
			} ),
		};

		return (
			<div>
				<Select
					value={ JSON.parse( faqGroupId ) }
					//isMulti={multi}
					onChange={ ( val ) => this.updateFaqsGroupSelect( val ) }
					options={ this.state.groups }
					className="react-select-container"
					classNamePrefix="react-select"
					placeholder="Select FAQs groups to display.."
					styles={ selectStyles }
				/>
			</div>
		);
	}
}
